import * as React from "react";

import { Drawer, DrawerContent } from "@/components/ui/drawer";
import { usePathname } from "@/lib/i18n";
import { useAppSelector } from "@/services/hooks/redux.hooks";

import { ExchangeSwitcher } from "./global/exchange-swticher";
import { Nav } from "./nav";

export function MobileSidebar() {
  const pathname = usePathname();
  const [open, setOpen] = React.useState(false);
  const { options } = useAppSelector((state) => state.sidebar);

  return (
    <Drawer open={open} onOpenChange={setOpen} direction="left">
      {/* <DrawerTrigger asChild>
        <Button variant="secondary" className="px-2">
          <PanelLeft />
        </Button>
      </DrawerTrigger> */}
      <DrawerContent className="bg-white flex flex-col rounded-sm h-full md:w-[300px] w-[75%] ">
        {!pathname.includes("/settings") ? (
          <>
            <ExchangeSwitcher />
          </>
        ) : (
          <div className="h-4"></div>
        )}

        <Nav isCollapsed={false} links={options} />
      </DrawerContent>
    </Drawer>
  );
}
